/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-07 11:46:42
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-07-07 11:53:53
 */
import YxString from "./String";
import PropTypes from "prop-types";
import { ITextBasePropTypes } from "../IpropType/basePropTypes";

YxString.propTypes = {
  ...ITextBasePropTypes,
  isReplace: PropTypes.bool,
  replaceLength: PropTypes.number,
  replaceType: PropTypes.oneOf(["left", "center", "right"]),

  replaceAppointStr: PropTypes.string,
  replaceStr: PropTypes.string,
  replaceStrLength: PropTypes.number,
  isComma: PropTypes.bool,
};
YxString.defaultProps = {
  isReplace: false, //是否开启替换
  replaceLength: 4, //替换长度
  replaceType: "center", //替换方式，左边，右边，中间  left、center、right
  replaceAppointStr: "", //指定替换某特定字符,如指定后，length和type将失效
  replaceStr: "*", //替代符号
  replaceStrLength: null, //替代符号长度，、、
};
export default YxString;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/String/index.js